export default __webpack_public_path__ + "static/imgGAPpng-131add609db28c75c250d4d6ce011797.png";